/* Sohi — mobile nav drawer, toggled by the header burger button. */
(function () {
  "use strict";

  var MQ = window.matchMedia("(max-width:900px)");

  function closeAll(restoreFocus) {
    closeDrops(null, restoreFocus);
    document.querySelectorAll('[data-nav-toggle][aria-expanded="true"]').forEach(function (btn) {
      var nav = document.getElementById(btn.getAttribute("aria-controls"));
      var focusInMenu = nav && nav.contains(document.activeElement);
      if (nav) nav.removeAttribute("data-open");
      btn.setAttribute("aria-expanded", "false");
      if (restoreFocus && focusInMenu) btn.focus();
    });
  }

  /* ---- Shop dropdown ------------------------------------------------
     One disclosure per nav item marked [data-nav-drop]: the link still
     goes to /shop.html, the caret button beside it opens a panel listing
     the catalog. On desktop the panel is an absolutely-positioned card
     under the header; on phones it's an accordion inside the drawer.
     Contents come from window.SohiCatalog so the menu can never drift
     from the products themselves — if the catalog script hasn't loaded
     (or, on Shopify, isn't used at all) the caret hides itself and Shop
     stays a plain link. */

  function closeDrops(except, restoreFocus) {
    document.querySelectorAll('[data-nav-drop-toggle][aria-expanded="true"]').forEach(function (btn) {
      if (btn === except) return;
      var menu = document.getElementById(btn.getAttribute("aria-controls"));
      var focusInMenu = menu && menu.contains(document.activeElement);
      if (menu) menu.hidden = true;
      btn.setAttribute("aria-expanded", "false");
      var item = btn.closest("[data-nav-drop]");
      if (item) item.dispatchEvent(new CustomEvent("sohi:unpin"));
      if (restoreFocus && focusInMenu) btn.focus();
    });
  }

  /* Shop lists ONLY the boxes now. The cups left this menu on 2 Sep with the
     decision that single cups can't be bought — a $3.60 row leading to an
     add-to-cart page the shop grid itself no longer offers was a lie in two
     places. The cups live in the Flavors dropdown beside this one instead,
     linking to their landing pages, priceless because they carry no price. */
  function shopDropHtml(catalog) {
    // The Best Value Bundle leads the list — it is the range's headline
    // offer, and the four flavour boxes follow at their shared price.
    var products = (catalog.bundles || []).concat(catalog.boxes);
    var links = products.map(function (p) {
      return '<a class="nav__droplink" href="' + catalog.productUrl(p) + '">' +
        '<span>' + p.name + '</span>' +
        '<span class="nav__dropprice">' + catalog.money(catalog.minPrice(p)) + '</span>' +
      '</a>';
    }).join("");
    return '<div class="nav__dropgroup"><p class="nav__dropheading">Boxes</p>' + links + '</div>' +
      '<a class="nav__dropall" href="/shop.html">Shop all</a>';
  }

  /* The Flavors menu: the four cups by their lid names (Choco Rush, not
     "Chocolate Protein Cup"), each to its flavour landing page. The footer
     row points at the boxes because that is the only way to buy one. */
  function flavorsDropHtml(catalog) {
    var links = catalog.cups.map(function (p) {
      return '<a class="nav__droplink" href="' + catalog.productUrl(p) + '">' +
        '<span>' + (p.flavorName || p.name) + '</span>' +
      '</a>';
    }).join("");
    return '<div class="nav__dropgroup">' + links + '</div>' +
      '<a class="nav__dropall" href="/shop.html">Get them in a box</a>';
  }

  function initDrop(item) {
    if (item.dataset.sohiDropReady === "true") return;
    item.dataset.sohiDropReady = "true";

    var link = item.querySelector("a");
    var btn = item.querySelector("[data-nav-drop-toggle]");
    var menu = item.querySelector("[data-nav-drop-menu]");
    var catalog = window.SohiCatalog;
    if (!btn || !menu) return;

    var hasCatalog = !!(catalog && catalog.all && catalog.all.length);

    // No catalog AND nothing pre-rendered in the panel — leave the item as an
    // ordinary link. On Shopify the panel arrives pre-filled from
    // sohi-header.liquid's menu rendering, so it falls through to the wiring
    // below without the catalog; only a genuinely empty panel hides the caret.
    // (`hidden` alone is not enough: .nav__dropbtn sets display:grid as an
    // author rule, which beats the UA stylesheet's [hidden] — hence the
    // explicit display too.)
    if (!hasCatalog && !menu.children.length) {
      btn.hidden = true;
      btn.style.display = "none";
      return;
    }

    // data-nav-drop="flavors" marks the Flavors item; a bare data-nav-drop
    // is the Shop item it always was. With the catalog present the panel is
    // built from it; without one the server-rendered contents stand.
    if (hasCatalog) {
      menu.innerHTML = item.dataset.navDrop === "flavors"
        ? flavorsDropHtml(catalog)
        : shopDropHtml(catalog);
    }

    function open() {
      closeDrops(btn);
      menu.hidden = false;
      btn.setAttribute("aria-expanded", "true");
    }
    function close() {
      menu.hidden = true;
      btn.setAttribute("aria-expanded", "false");
    }

    // `pinned` is what the click opened, as opposed to what hover opened.
    // Without it the two paths fight on desktop: clicking the caret first
    // moves the pointer onto the item, so mouseenter opens the panel and
    // the click that follows reads it as already-open and closes it again.
    // Hover may only close a panel it opened itself.
    var pinned = false;

    function toggle(e) {
      e.stopPropagation();
      if (pinned) { pinned = false; close(); }
      else { pinned = true; open(); }
    }

    function openHover() { if (!MQ.matches && !pinned) open(); }
    function closeHover() { if (!MQ.matches && !pinned) close(); }

    btn.addEventListener("click", toggle);

    // Clicking the "Shop" word itself opens the panel instead of navigating
    // straight to /shop.html, on desktop and in the mobile drawer alike —
    // the caret beside it is a tiny target, the link text is the obvious
    // place to tap. A modifier/middle click still opens /shop.html normally.
    if (link) {
      link.addEventListener("click", function (e) {
        if (e.defaultPrevented) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        toggle(e);
      });
    }

    item.addEventListener("mouseenter", openHover);
    item.addEventListener("mouseleave", closeHover);

    // Keyboard: tabbing out of the whole item closes it.
    item.addEventListener("focusout", function (e) {
      if (!item.contains(e.relatedTarget)) { pinned = false; close(); }
    });

    // Any external close (outside click, Escape, drawer toggle) has to drop
    // the pin too, or the next click would read as "close" on a shut panel.
    item.addEventListener("sohi:unpin", function () { pinned = false; });
  }

  function init(btn) {
    if (btn.dataset.sohiReady === "true") return;
    btn.dataset.sohiReady = "true";

    var nav = document.getElementById(btn.getAttribute("aria-controls"));
    if (!nav) return;

    btn.addEventListener("click", function () {
      var wasOpen = btn.getAttribute("aria-expanded") === "true";
      closeAll();
      if (!wasOpen) {
        nav.setAttribute("data-open", "");
        btn.setAttribute("aria-expanded", "true");
      }
    });

    nav.addEventListener("click", function (e) {
      var a = e.target.closest("a");
      // The Shop link's own handler (initDrop, above) intercepts this same
      // click to open the dropdown/accordion instead of navigating — if
      // this listener still closed the whole drawer on it, the dropdown
      // would open and vanish in the same tick. defaultPrevented is that
      // handler's signal that this click didn't actually go anywhere.
      if (a && !e.defaultPrevented) closeAll();
    });
  }

  document.addEventListener("click", function (e) {
    if (!e.target.closest("[data-nav-drop]")) closeDrops();
    document.querySelectorAll('[data-nav-toggle][aria-expanded="true"]').forEach(function (btn) {
      var nav = document.getElementById(btn.getAttribute("aria-controls"));
      if (nav && !nav.contains(e.target) && !btn.contains(e.target)) closeAll();
    });
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeAll(true);
  });

  MQ.addEventListener("change", closeAll);

  function boot(root) {
    (root || document).querySelectorAll("[data-nav-toggle]").forEach(init);
    (root || document).querySelectorAll("[data-nav-drop]").forEach(initDrop);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
